import { Box, Button, Divider, IconButton, Typography } from '@mui/material';
import styles from './OfficesList.module.css';
import BasePageStructure from 'src/components/BasePageStructure';
import { GridColDef } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { GetEmployees_Out, GetOffice_Out, OfficeState } from 'src/pehra-ts-client';
import AppStripedDataGrid from 'src/components/AppStripedDataGrid';
import SearchBar from 'src/components/SearchBar';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useNavigate, useParams } from 'react-router-dom';
import OfficeItem from '../OfficeItem';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';

export interface IOfficesList {
  parentOfficeDetail: GetOffice_Out | null;
  parentId: string | null;
  offices: GetOffice_Out[];
  handleNewOfficeClick: () => void;
}

const OfficesList: React.FC<IOfficesList> = ({ parentId, parentOfficeDetail, offices, handleNewOfficeClick }) => {
  const [selectedOffice, setSelectedOffice] = useState<GetOffice_Out | null>(null);

  const navigate = useNavigate();

  // add click listener to outer container
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (e.target instanceof HTMLElement) {
        setSelectedOffice(null);
      }
    };
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  return (
    <Box className={styles.container}>
      <Box className={styles.officesContainer}>
        {offices.map((office) => {
          return (
            <Box
              key={office.id}
              onClick={() => {
                navigate(`/office/${office.id}`);
                // setSelectedOffice(office);
              }}
            >
              <OfficeItem office={office} isSelected={selectedOffice?.id === office.id} />
            </Box>
          );
        })}
        <Box>
          {/* grid border box with plus icon and text add new office */}
          <Button variant="light" className={styles.addNewOfficeContainer} onClick={handleNewOfficeClick}>
            <CreateNewFolderIcon className={styles.folderIcon} />
            <Typography variant="h6">Add New Office</Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default OfficesList;
